import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { AppMenuItem } from "@jugl-web/rest-api";
import { FC, ReactNode } from "react";

export interface DraggableItemProps {
  id: AppMenuItem;
  index: number;
  children: ReactNode;
}

export const DraggableItem: FC<DraggableItemProps> = ({
  id,
  index,
  children,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
    data: { index },
  });

  return (
    <div
      ref={setNodeRef}
      style={{
        opacity: isDragging ? 0 : undefined,
        transform: CSS.Translate.toString(transform),
        transition,
      }}
      {...attributes}
      {...listeners}
    >
      {children}
    </div>
  );
};
